module.exports = __webpack_public_path__ + "static/img/banner_01.f43b6f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/products/banner_01.png
// module id = XPH4
// module chunks = 6